module.exports = __webpack_public_path__ + "img/grey-30days.317fa52b.png";